import { render, staticRenderFns } from "./VipcodeDialog.vue?vue&type=template&id=cbff085c&scoped=true&"
import script from "./VipcodeDialog.vue?vue&type=script&lang=js&"
export * from "./VipcodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./VipcodeDialog.vue?vue&type=style&index=0&id=cbff085c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbff085c",
  null
  
)

export default component.exports